// extracted by mini-css-extract-plugin
export default {"listContainer":"WhyList_listContainer__0VKHs","list":"WhyList_list__hHa4N","title":"WhyList_title__7xf+y","info":"WhyList_info__Tay3+"};